import React from 'react';
//dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { RadioGroup } from '@swiggy-private/dls-web-core/dist/components/RadioGroup';
//stores
import useSearchCampaignStore from '@/stores/SearchCampaign';
//constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
//styles
import styles from './Filters.module.scss';
const radioOptions = [
    {
        label: 'Yes',
        value: 'TRUE',
    },
    {
        label: 'No',
        value: 'FALSE',
    },
];
const AdPacing = () => {
    const { pacingEnabled, setPacingEnabled } = useSearchCampaignStore((state) => ({
        pacingEnabled: state.pacingFilter.pacingEnabled,
        setPacingEnabled: state.pacingFilter.setPacingEnabled,
    }));
    const getRadioValue = () => {
        if (pacingEnabled === true) {
            return 'TRUE';
        }
        if (pacingEnabled === false) {
            return 'FALSE';
        }
        return '';
    };
    return (React.createElement("div", null,
        React.createElement(Text, { className: styles.filterLabel, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Highest_Emphasis }, "Ad Pacing"),
        React.createElement(RadioGroup, { name: "pacing-filter", value: getRadioValue(), items: radioOptions, onChange: (e) => {
                const value = e.target.value;
                setPacingEnabled(value === 'TRUE' ? true : false);
            } })));
};
export default AdPacing;
